// extracted by mini-css-extract-plugin
export default {"container":"SubmissionItem__container___qfFDG","textInputContainer":"SubmissionItem__textInputContainer___Wj5JR","subtleText":"SubmissionItem__subtleText___jNxCO"};